module.exports = __webpack_public_path__ + "assets/meeting.0f098a89f5720f28b96f6132dddc2b8d.svg";